// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2xQgC","filesListContainer":"PosDisputesFiles_filesListContainer__8XcR0","filesButton":"PosDisputesFiles_filesButton__3IbpR"};